"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.check = void 0;
var check = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "check",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "check",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "12 5 4 13 0 9 1.5 7.5 4 10 10.5 3.5"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "12 5 4 13 0 9 1.5 7.5 4 10 10.5 3.5"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.check = check;